export const formatSubscribePrice = (centPrice: number = 0) => {
  const price = centPrice / 100
  const transPrice = Number(price.toFixed(2))
  return Number.isInteger(transPrice)
    ? transPrice.toFixed(1).toString()
    : transPrice.toString()
}

export const formatMessageAmount = (
  t: (key: string) => string,
  msgAmount: number | 'inf',
  type: 'message' | 'gem' = 'message'
) => {
  if (msgAmount === 'inf') {
    return type === 'gem' ? '∞' : t('Unlimited')
  }
  return msgAmount.toLocaleString()
}

export const getDaysPassed = (startTime: number): number => {
  // 计算从开始时间到现在的完整24小时周期数
  const now = Date.now()
  return Math.floor((now - startTime) / (24 * 60 * 60 * 1000))
}

export const isPositiveIntegerAmount = (value: string) =>
  /^\d+$/.test(value) && Number(value) > 0
